module.exports = __webpack_public_path__ + "static/media/sourcesanspro-italic-webfont.12c96d9d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/source-sans-pro/sourcesanspro-italic-webfont.woff
// module id = 507
// module chunks = 0